import log from 'common/services/logging/loggers';
import * as Sentry from '@sentry/browser';

const exceptionHandler = ['$provide', ($provide) => {

    const extendExceptionHandler = ($delegate) => {

        const appErrorPrefix = '--------------->>>>>>>>>>>>>>>>>>>>>>>>>>';
        return (exception, cause) => {

            if (CWCONFIG.features.customDebug) {

                $delegate(exception, cause);
                if (appErrorPrefix &&
                    exception.message &&
                    exception.message.indexOf(appErrorPrefix) === 0) {

                    return;

                }

                const errorData = {
                    exception,
                    cause,
                };
                const msg = appErrorPrefix + exception.message;
                log.error(appErrorPrefix, errorData);

                const body = angular.element('body');

                body.append(`${'<div class="testing" style="width:400px; padding:20px;' +
                    'background-color:#b45555; position:fixed; top:0; color:#fff; max-height:300px;' +
                    'z-index:1000; font-size:14px; word-break:break-word; overflow:auto;">'}${
                    errorData.exception.message}______${msg}___${JSON.stringify(errorData.exception)}</div>`);

                Sentry.withScope((scope) => {

                    scope.setLevel('error');
                    Sentry.captureMessage(`Internal JS error: ${errorData.exception.message}______${msg}___${JSON.stringify(errorData.exception)}`);

                });

            }

        };

    };

    $provide.decorator('$exceptionHandler', ['$delegate', extendExceptionHandler]);

}];

export default exceptionHandler;



// WEBPACK FOOTER //
// ./scripts/app/exceptionHandler.js